import React, { Component } from 'react';
import ReactGA from 'react-ga';

import Icon from './Icon';

class Result extends Component {
  constructor(props) {
    super(props);

    this.state = {
      results: [],
      totalUnits: 0,
      totalCalories: 0
    };

    this.topElementRef = React.createRef();
  }

  smoothScrollToElement(ref) {
    ref.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  componentDidMount() {
    let results = [];
    let totalUnits = 0;
    let totalCalories = 0;

    // Loop through all possible drinks, calculcating the number of units that
    // this contributes to the total
    this.props.drinks.forEach(drink => {
      if (this.props.answers[drink.name] !== 0 && this.props.answers[drink.name] !== '') {
        let unitsFromThisDrink = drink.units * this.props.answers[drink.name];
        let caloriesFromThisDrink = drink.calories * this.props.answers[drink.name];
        results.push({
          name: drink.name,
          abv: drink.abv,
          icon: drink.icon,
          quantity: this.props.answers[drink.name],
          // Round units to 1 decimal place but render integers without decimals
          units:
            unitsFromThisDrink.toString().indexOf('.') !== -1
              ? unitsFromThisDrink.toFixed(1)
              : unitsFromThisDrink,
          calories: caloriesFromThisDrink
        });
        totalUnits = totalUnits + unitsFromThisDrink;
        totalCalories = totalCalories + caloriesFromThisDrink;
      }
    });

    this.setState({
      results: results,
      totalUnits: totalUnits.toFixed(1),
      totalCalories: totalCalories
    });

    // Send an analytics event
    ReactGA.event({
      category: 'Impact tool',
      action:
        this.props.user.gender === 'Self describe'
          ? 'Self describe: ' + this.props.user.genderCustom
          : this.props.user.gender,
      label: totalCalories.toString(),
      value: totalUnits
    });

    this.smoothScrollToElement(this.topElementRef);
  }

  renderIcons(icon, count) {
    let icons = [];

    for (var i = 0; i < count; i++) {
      icons.push(<Icon name={icon} className="u-h-8 u-w-8" key={icon + '_' + i} />);
    }

    return <div className="u-text-purple u-mt-2">{icons}</div>;
  }

  render() {
    return (
      <div
        className="u-absolute u-container u-mx-auto u-max-w-md md:u-p-4 u-mt-0"
        ref={this.props.innerRef}
      >
        <h2 ref={this.topElementRef}>Your results</h2>
        {this.state.results.map((drink, index) => (
          <div
            key={drink.name}
            className="u-flex u-justify-between u-mt-0 u-pt-4 u-pb-4 border-bottom"
          >
            <div className="u-flex-grow">
              <p className="u-font-bold">
                {drink.name} ({drink.abv}%)
              </p>
              {this.renderIcons(drink.icon, drink.quantity)}
            </div>
            <div className="u-mt-0 u-text-center">
              <p className="u-font-bold u-leading-tight">Units</p>
              <p className="u-mt-2 u-text-2xl u-font-bold">{drink.units}</p>
            </div>
          </div>
        ))}
        <div className="u-flex u-justify-between u-text-center">
          <div>
            <p className="u-text-white u-bg-orange u-font-bold u-mt-0 u-py-1 u-px-4">Calories</p>
            <p className="u-font-bold u-text-3xl u-mt-2">{this.state.totalCalories}</p>
          </div>
          <div className="u-mt-0">
            <p className="u-text-white u-bg-orange u-font-bold u-mt-0 u-py-1 u-px-4">
              Total units per week
            </p>
            <p className="u-font-bold u-text-3xl u-mt-2">{this.state.totalUnits}</p>
          </div>
        </div>
        {(() => {
          if (this.state.totalUnits <= 14) {
            // All genders 14 and under units per week
            return (
              <p>
                Good news! You are drinking within the recommended guidelines and are less likely to
                develop alcohol-related problems
              </p>
            );
            // All genders between 15 and 34, plus 'Male' between 15 and 49 units per week
          } else if (
            (this.state.totalUnits >= 15 && this.state.totalUnits <= 34) ||
            (this.state.totalUnits >= 15 &&
              this.state.totalUnits <= 49 &&
              this.props.user.gender === 'Male')
          ) {
            return (
              <p>
                Watch out! You are drinking at levels that could put your health at risk and you
                would benefit from cutting down
              </p>
            );
            // Women 35+ and men 50+ units
          } else if (
            (this.state.totalUnits >= 35 && this.props.user.gender === 'Female') ||
            (this.state.totalUnits >= 50 && this.props.user.gender === 'Male')
          ) {
            return (
              <p>
                Drinking at this level is likely to be harming your health. You may wish to speak to
                your GP or an alcohol professional to look at your options for taking back control
                of your drinking.
                <br />
                <a href="/help-and-support/get-help-now">
                  You can find out more about the types of support that are available here
                </a>
                .
              </p>
            );
            // All other genders with 35+ units per week
          } else if (this.state.totalUnits >= 35) {
            return (
              <p>
                Drinking at this level is likely to be harming your health. You may wish to speak to
                your GP or an alcohol professional to look at your options for taking back control
                of your drinking.
                <br />
                <a href="/help-and-support/get-help-now">
                  You can find out more about the types of support that are available here
                </a>
                .
              </p>
            );
          }
        })()}
        <button
          type="button"
          onClick={this.props.resetToInitialState}
          className="button button--back u-mt-4"
        >
          Check again
        </button>
      </div>
    );
  }
}

export default Result;
